import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { Typography } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { useAlternatePickClickAnalytics } from '../../hooks';
type AlternatePickTitleCtaProps = {
  ctaAnalytics: NonNullable<ReviewCreditCardsPage['alternatePicks'][number]['marketplaceEntity']>['ctaAnalytics'];
  reviewLink: string;
  isActive: boolean;
  name: string;
  parentActivityId: string;
};
export default function AlternatePickTitleCta(t0) {
  const $ = _c(6);
  const {
    ctaAnalytics,
    reviewLink,
    isActive,
    name,
    parentActivityId
  } = t0;
  const {
    fireClickPageAction
  } = useAlternatePickClickAnalytics("title", parentActivityId);
  let t1;
  if ($[0] !== ctaAnalytics || $[1] !== fireClickPageAction || $[2] !== isActive || $[3] !== name || $[4] !== reviewLink) {
    t1 = isActive ? <CtaLink analytics={ctaAnalytics} href={reviewLink} width="fit-content" parameterActions={[]} skipShoppingFinishedEvent={true} isReview={true} onClickAnalyticsCallback={fireClickPageAction} data-testid="alternativePickCardName"><Typography variant="textBold" color="black">{name}</Typography></CtaLink> : <Typography variant="textBold" color="black">{name}</Typography>;
    $[0] = ctaAnalytics;
    $[1] = fireClickPageAction;
    $[2] = isActive;
    $[3] = name;
    $[4] = reviewLink;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}